export default __webpack_public_path__ + "static/media/shape_04.cf7506d6.png";